// export const parseJwt = (token) => {
//   try {
//     return JSON.parse(atob(token.split(".")[1]));
//   } catch (e) {
//     return null;
//   }
// };

// Add by Victor
export const parseJwt = (token) => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
};

//Get current user
const GetCurrentUser = () => {
  let user = localStorage.getItem("LogedUser");
  return user;
};

export const parsedUser = () => {
  let user = GetCurrentUser();
  let parsed = parseJwt(user);
  return parsed;
};
export default GetCurrentUser;
